import type { ApiClient } from '../client';
import type { CreateHolidayRequest, ListHolidaysResponse, Uuid } from '../types';

export function bindHolidays(client: ApiClient) {
  return {
async listHolidays(academicYearId?: string) {
    const qs = academicYearId ? `?academic_year_id=${encodeURIComponent(academicYearId)}` : '';
    const resp = await client.request<ListHolidaysResponse>(`/academic-planning/holidays${qs}`);
    // Empty / missing list is success — normalize so callers never break on null.
    const holidays = Array.isArray(resp.data?.holidays) ? resp.data.holidays : [];
    return {
      ...resp,
      data: {
        ...(resp.data ?? { holidays: [] }),
        holidays,
      },
    };
  },

async createHoliday(body: CreateHolidayRequest) {
    return client.request<{ holiday_id: Uuid }>('/academic-planning/holidays', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

// Export API
  async exportData(type: 'students' | 'teachers' | 'courses' | 'grades', format: 'csv' | 'excel' | 'pdf'): Promise<Blob> {
    const response = await fetch(`${client.baseUrl}/api/export/${type}?format=${format}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Export failed: ${response.statusText}`);
    }

    return response.blob();
  }
  };
}
